import React, { useEffect, useState } from "react";
import Container from "reactstrap/lib/Container";
import AppCard from "./AppCard";
import { getAllApps } from "api/AppsApi";
import { getPermissions } from 'api/UsersApi'
import SupportLink from "../../Common/SupportLink";

const AllApps = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [appInstallPermission, setAppInstallPermission] = useState(false);
  const [permissionMessage, setPermissionMessage] = useState(null);
  const [showPermissionMessage, setShowPermissionMessage] = useState(true);

  useEffect(() => {
    getAllApps()
      .then((data) => {
        setDataApi(data);
      })
      .catch((e) => { });
    getPermissions().then(res => {
      setAppInstallPermission(res['InstallApp'].allowed);
      setPermissionMessage(res['InstallApp'].message);
    })
  }, []);

  const messageBar = (permissionMessage) => {
    if (permissionMessage) {
      return (
        showPermissionMessage && <div className="apps-message" style={{ width: '100%', height: '50px', backgroundColor: '#FEF6E6', color: 'rgb(237 146 23)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "DM Sans", fontSize: '16px', padding: '35px' }}>
          <div dangerouslySetInnerHTML={{ __html: permissionMessage }} className='messagebar__text'></div>

          <span onClick={() => {
            setShowPermissionMessage(false)
          }} style={{ marginLeft: '10px', fontSize: '15px', cursor: 'pointer' }}> <i className="fa fa-times"></i> </span>
        </div>
      )
    }
  }
  return (
    <Container>
      {
        messageBar(permissionMessage)
      }
      <SupportLink link='https://kapitalwise.com/user-guide/settings#apps_setup' />

      <div className="page_heading">
        <h2>All Apps</h2>
      </div>

      <div className="template_block">
        <div className="row templates-row" style={{ margin: "2vh" }}>
          {dataApi
            ? dataApi.map((app, idx) => {
              return <AppCard key={"app" + idx} data={app} appInstallPermission={appInstallPermission} />;
            })
            : null}
        </div>
      </div>
    </Container>
  );
};

export default AllApps;
